<template>
  <div class="exhibition-container">
    <el-row>
      <div style="width: 250px; float: right; margin-right: 50px">
        <el-tabs class="tfam-custom-tabs" v-model="activeName" @tab-click="handleSwitchListClick">
          <el-tab-pane label="展覽列表" name="now"></el-tab-pane>
          <el-tab-pane label="歷史項目" name="history"></el-tab-pane>
          <el-tab-pane label="舊資料" name="older"></el-tab-pane>
        </el-tabs>
      </div>
    </el-row>
    <!-- 2020前舊資料-->
    <el-row v-if="activeName === 'older'">
      <div class="tfam-table-search">
        <span class="ti-search"></span>
        <input v-model="searchOlderKey" class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
      </div>
      <el-table
        :data="showOlderExhibitionList"
        v-loading="listLoading"
        :show-header="false"
        :row-style="rowStyle"
        :cell-style="cellStyle"
        empty-text="無資料"
        style="width: 100%;">
        <el-table-column
          type="image"
          width="80">
          <template slot-scope="scope">
            <div class="image-content list-image demo-image__error">
              <div class="block">
                <el-image :src="getImageUrl(scope.row)" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          min-width="300">
          <template slot-scope="scope">
            <div class="exhibition-title" @click="goExhibition('older', scope.row._id)">
              <span class="exhibition-title-cht">{{ scope.row.title ? scope.row.title.text_cht : ''}}</span>
              <br>
              <span class="exhibition-title-eng">{{ scope.row.title ? scope.row.title.text : ''}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="open"
          label="時間"
          width="200">
          <template slot-scope="scope">
            <span>{{ scope.row | olderOpenFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="guide"
          label="guideAndResponse"
          width="200">
          <template slot-scope="scope">
            <el-button round size="mini" @click="goCollectionList('older', scope.row._id)">{{ scope.row._id | olderCollectionFilter }} 件展品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchOlderKey.trim().length === 0"
        :page-size="10"
        :pager-count="11"
        :hide-on-single-page="true"
        :current-page.sync="olderListQuery.page"
        :total="olderExhibitionList.length"
        layout="prev, pager, next"
        @current-change="handleOlderFilter">
      </el-pagination>
    </el-row>
    <!-- 新資料-->
    <el-row v-else>
      <div v-if="activeName === 'history'">
        <el-table
          :data="historyExhibitionList"
          v-loading="listLoading"
          :show-header="false"
          :row-style="rowStyle"
          :cell-style="cellStyle"
          empty-text="無資料"
          style="width: 100%;"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave">
          <el-table-column
            type="image"
            width="80">
            <template slot-scope="scope">
              <div class="image-content list-image demo-image__error">
                <div class="block">
                  <el-image :src="getExhibitionImage(scope.row)" fit="cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名稱"
            max-width="1000"
            min-width="100">
            <template slot-scope="scope">
              <div class="exhibition-title" @click="goExhibition('new', scope.row.exhibition_id)">
                <span class="exhibition-title-cht">{{ scope.row | titleFilter }}</span>
                <br>
                <span class="exhibition-title-eng">{{ scope.row | engTitleFilter}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="open"
            label="時間"
            width="160">
            <template slot-scope="scope">
              <span>{{ scope.row | openFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="點擊次數"
            width="70">
            <template slot-scope="scope">
              <div style="text-align: right">
                <span>點擊次數</span>
                <br>
                <span>{{ scope.row | tapCountFilter }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="guide"
            label="guideAndResponse"
            width="120">
            <template slot-scope="scope">
              <div class="guide-button-content">
                <span @click="goCollectionList('new', scope.row.exhibition_id)">{{ scope.row.collections.length }} 件展品</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="public"
            label="預備"
            width="50">
            <template slot-scope="scope">
              <div class="public-content">
                <el-tooltip class="item" effect="dark" content="變更為準備中狀態" placement="top">
                  <span class="tfam-pub" @click="handleUpdateStatus(scope.row, 'prepare')"></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <!--
        <div class="show-d">
          <el-tag>old order :</el-tag> {{ exhibitionNameFilter(oldList) }}
        </div>
        <div class="show-d">
          <el-tag>new order :</el-tag> {{ exhibitionNameFilter(newList) }}
        </div>
        -->
        <el-table
          ref="dragTable"
          :data="onlineExhibitionList"
          v-loading="listLoading"
          :show-header="false"
          :row-style="rowStyle"
          :cell-style="cellStyle"
          empty-text="無資料"
          style="width: 100%;"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave">
          <el-table-column
            type="image"
            width="80">
            <template slot-scope="scope">
              <div class="image-content list-image demo-image__error">
                <div class="block">
                  <el-image :src="getExhibitionImage(scope.row)" fit="cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名稱"
            max-width="1000"
            min-width="100">
            <template slot-scope="scope">
              <div class="exhibition-title" @click="goExhibition('new', scope.row.exhibition_id)">
                <span class="exhibition-title-cht">{{ scope.row | titleFilter }}</span>
                <br>
                <span class="exhibition-title-eng">{{ scope.row | engTitleFilter}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="enableEn"
            label="是否顯示英文"
            width="50">
            <template slot-scope="scope">
              <div class="keep">
                <!-- 強制KEEP顯示，即使展覽結束後仍會顯示在APP中 -->
                <el-tooltip class="item" effect="dark" content="啟用顯示英文展覽與否" placement="top">
                  <el-checkbox v-model="scope.row.enable_en" @change="handleChangeEnableEn(scope.row.exhibition_id)"></el-checkbox>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="keep"
            width="70">
            <template slot-scope="scope">
              <div class="keep">
                <!-- 強制KEEP顯示，即使展覽結束後仍會顯示在APP中 -->
                <el-tooltip v-if="scope.row.status === 'online'" class="item" effect="dark" content="強制KEEP顯示，即使展覽結束後仍會顯示在APP中" placement="top">
                  <span class="online" @click="handleUpdateStatus(scope.row, 'keep')">KEEP</span>
                </el-tooltip>
                <!-- 取消KEEP -->
                <el-tooltip v-else class="item" effect="dark" content="取消KEEP狀態(若展覽結束時間已過，系統將自動下架，並移往歷史展覽)" placement="top">
                  <span class="inKeep" @click="handleUpdateStatus(scope.row, 'inKeep')">KEEP</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="open"
            label="時間"
            width="160">
            <template slot-scope="scope">
              <span>{{ scope.row | openFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="點擊次數"
            width="70">
            <template slot-scope="scope">
              <div style="text-align: right">
                <span>點擊次數</span>
                <br>
                <span>{{ scope.row | tapCountFilter }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="guide"
            label="guideAndResponse"
            width="120">
            <template slot-scope="scope">
              <div class="guide-button-content">
                <span @click="goCollectionList('new', scope.row.exhibition_id)">{{ scope.row.collections.length }} 件展品</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="拖曳順序" width="50">
            <template slot-scope="{}">
              <i class="el-icon-rank drag-handler" style="cursor: move"></i>
            </template>
          </el-table-column>
          <el-table-column
            prop="public"
            label="下架"
            width="50">
            <template slot-scope="scope">
              <div class="public-content">
                <el-tooltip class="item" effect="dark" content="變更為下架狀態" placement="top">
                  <span class="tfam-unPub" @click="handleUpdateStatus(scope.row, 'offline')"></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row v-if="prepareExhibitionList.length > 0" class="invisible-title">
          <span>準備中</span>
        </el-row>
        <el-table
          v-if="prepareExhibitionList.length > 0"
          :data="prepareExhibitionList"
          v-loading="listLoading"
          :show-header="false"
          :row-style="rowStyle"
          :cell-style="cellStyle"
          empty-text="無資料"
          style="width: 100%;"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave">
          <el-table-column
            type="image"
            width="80">
            <template slot-scope="scope">
              <div class="image-content list-image demo-image__error">
                <div class="block">
                  <el-image :src="getExhibitionImage(scope.row)" fit="cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名稱"
            max-width="1000"
            min-width="100">
            <template slot-scope="scope">
              <div class="exhibition-title" @click="goExhibition('new', scope.row.exhibition_id)">
                <span class="exhibition-title-cht">{{ scope.row | titleFilter }}</span>
                <br>
                <span class="exhibition-title-eng">{{ scope.row | engTitleFilter}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="keep"
            width="70"/>
          <el-table-column
            prop="open"
            label="時間"
            width="160">
            <template slot-scope="scope">
              <span>{{ scope.row | openFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="點擊次數"
            width="70">
            <template slot-scope="scope">
              <div style="text-align: right">
                <span>點擊次數</span>
                <br>
                <span>{{ scope.row | tapCountFilter }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="guide"
            label="guideAndResponse"
            width="120">
            <template slot-scope="scope">
              <div class="guide-button-content">
                <span @click="goCollectionList('new', scope.row.exhibition_id)">{{ scope.row.collections.length }} 件展品</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="拖曳順序" width="50" />
          <el-table-column
            prop="public"
            label="上架"
            width="50">
            <template slot-scope="scope">
              <div class="public-content">
                <el-tooltip class="item" effect="dark" content="變更為上架狀態" placement="top">
                  <span class="tfam-pub" @click="handleUpdateStatus(scope.row, 'online')"></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <div class="create-new" @click="goExhibition(false, 'new')">
      <span class="tfam-new"></span>
    </div>
  </div>
</template>

<script>
import exhibitionJSON from '../../transData/exhibitions'
import collectionJSON from '../../transData/collections'
import { parseTime } from '../../utils'
import {fetchExhibitionList, updateExhibition} from "../../api/exhibition";
import { getGCPFileUrl } from "../../api/attachment";
import Sortable from 'sortablejs'

export default {
  name: "ExhibitionList",
  computed: {
    rowStyle: function () {
      return {
        height: '80px',
        cursor: 'default'
      }
    }
  },
  data() {
    return {
      activeName: 'now',
      exhibitionList: [],
      onlineExhibitionList: [],
      prepareExhibitionList: [],
      historyExhibitionList: [],
      olderExhibitionList: [],
      showOlderExhibitionList: [],
      enableTransfer: this.$store.getters.user.name === 'rideawavefun',
      olderListQuery: {
        page: 1
      },
      currentHoverRow: '',
      searchOlderKey: '',
      listLoading: false,
      oldList: [],
      newList: []
    }
  },
  filters: {
    olderOpenFilter: function (row) {
      const openingHours = row['opening_hours'];
      if (openingHours) {
        return parseTime(openingHours['start'], '{y}/{m}/{d}') + '-' + parseTime(openingHours['end'], '{y}/{m}/{d}')
      } else {
        return ''
      }
    },
    olderCollectionFilter: function(id) {
      const filter = collectionJSON.filter(x => x['root'] === id);
      return filter.length;
    },
    titleFilter: function (row) {
      const filter = row['exhibitionLangs'].filter(x => x['language_key'] === 'ZH_TW');
      if (filter.length > 0) {
        return filter[0]['title'] ? filter[0]['title'] : '-'
      } else {
        return '-'
      }
    },
    engTitleFilter: function (row) {
      const filter = row['exhibitionLangs'].filter(x => x['language_key'] === 'EN');
      if (filter.length > 0) {
        return filter[0]['title'] ? filter[0]['title'] : '-'
      } else {
        return '-'
      }
    },
    openFilter: function (row) {
      return parseTime(row['open_start_at'], '{y}/{m}/{d}') + '-' + parseTime(row['open_end_at'], '{y}/{m}/{d}')
    },
    tapCountFilter: function (row) {
      let count = 0
      for (const i in row.exhibitionLangs) {
        count += row.exhibitionLangs[i]['tap_count']
      }
      return count
    },
  },
  watch: {
    searchOlderKey: function (val) {
      if (val && val.trim().length > 0) {
        this.showOlderExhibitionList = this.olderExhibitionList.filter(function(item, index, array){
          if (!item['title']) {
            return false
          }
          let filters = false;
          if (item['title']['text_cht'] && item['title']['text_cht'].includes(val)) {
            filters = true
          }
          if (item['title']['text'] && item['title']['text'].includes(val)) {
            filters = true
          }
          return filters
        });
      } else {
        this.handleOlderFilter()
      }
    }
  },
  mounted() {
    this.getExhibitionList();
    this.getExhibitionListFromOlder();
  },
  methods: {
    exhibitionNameFilter: function(list) {
      const nameList = [];
      if (this.onlineExhibitionList && this.onlineExhibitionList.length > 0) {
        for (const i in list) {
          const filterExhibition = this.onlineExhibitionList.filter(x => x['exhibition_id'] === list[i]);
          const filterTitle = filterExhibition[0]['exhibitionLangs'].filter(x => x['language_key'] === 'ZH_TW');
          nameList.push(filterTitle[0]['title'])
        }
      }
      return nameList
    },
    setSort() {
      const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function(dataTransfer) {
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.onlineExhibitionList.splice(evt.oldIndex, 1)[0];
          this.onlineExhibitionList.splice(evt.newIndex, 0, targetRow);

          // for show the changes, you can delete in you code
          const tempIndex = this.newList.splice(evt.oldIndex, 1)[0];
          this.newList.splice(evt.newIndex, 0, tempIndex);
          this.handleSubmitNewSort();
        }
      })
    },
    handleSubmitNewSort() {
      this.onlineExhibitionList = [];
      this.prepareExhibitionList = [];
      this.listLoading = true;
      this.submitNewSort().then(() => {
        this.listLoading = false;
        this.getExhibitionList();
      }).catch(error => {
        this.listLoading = false;
        this.$alert(error, '發生錯誤', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
      })
    },
    async submitNewSort() {
      try {
        const allPromise = [];
        for (const i in this.newList) {
          allPromise.push(updateExhibition(this.newList[i], {
            index_sort: parseInt(i)
          }))
        }
        await Promise.all(allPromise);
        return Promise.resolve(true);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    cellMouseEnter(row, column, cell, event) {
      this.currentHoverRow = row['exhibition_id']
    },
    cellMouseLeave(row, column, cell, event) {
      if (row['exhibition_id'] === this.currentHoverRow) {
        this.currentHoverRow = ''
      }
    },
    handleOlderFilter() {
      this.showOlderExhibitionList = this.olderExhibitionList.slice(
        (this.olderListQuery.page - 1) * 10, (this.olderListQuery.page) * 10);
    },
    getExhibitionImage(data) {
      if (data.images.length > 0) {
        return getGCPFileUrl(data.images[0]['name']);
      } else {
        return ''
      }
    },
    getImageUrl(data) {
      if (data['general_information'] &&
        data['general_information']['coverphoto'] &&
        data['general_information']['coverphoto']['value']) {
        const imagePath = 'images/' + data['general_information']['coverphoto']['value'] + '/0.jpg';
        return getGCPFileUrl(imagePath)
      } else {
        return ''
      }
    },
    handleSwitchListClick() {
      if (this.activeName === 'history' && this.historyExhibitionList.length === 0) {
        this.getHistoryExhibitionList();
      }
      console.log(this.activeName);
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === 'guideAndResponse') {
        return 'text-align:right; padding: 10px'
      } else {
        return ''
      }
    },
    getExhibitionListFromOlder() {
      this.currentHoverRow = '';
      this.exhibitionList = [];
      let filter = exhibitionJSON.filter(x => x['opening_hours'] && x['opening_hours']['start']);
      filter = filter.sort(function (a, b) {
        return new Date(a['opening_hours']['start']) > new Date(b['opening_hours']['start']) ? -1 : 1;
      });
      this.olderExhibitionList = filter;
      this.handleOlderFilter()
    },
    getExhibitionList() {
      this.listLoading = true;
      this.currentHoverRow = '';
      const filter = {
        where: {
          neq: [{
            status: 'history'
          }]
        },
        // order: 'open_start_at DESC',
        order: ['index_sort ASC', 'open_start_at DESC'],
        include: ['exhibitionLangs', 'collections']
      };
      fetchExhibitionList(filter).then(response => {
        this.listLoading = false;
        this.exhibitionList = response.data;
        this.onlineExhibitionList = this.exhibitionList.filter(x => x['status'] === 'online' || x['status'] === 'keep');
        this.prepareExhibitionList = this.exhibitionList.filter(x => x['status'] === 'prepare');
        this.oldList = this.onlineExhibitionList.map(v => v['exhibition_id']);
        this.newList = this.oldList.slice();
        this.$nextTick(() => {
          this.setSort()
        })
      }).catch(err => {
        this.listLoading = false;
      })
    },
    getHistoryExhibitionList() {
      this.listLoading = true;
      this.currentHoverRow = '';
      const filter = {
          where: {
            status: 'history'
          },
        include: ['exhibitionLangs', 'collections']
      };
      fetchExhibitionList(filter).then(response => {
        this.listLoading = false;
        this.historyExhibitionList = response.data;
      }).catch(err => {
        this.listLoading = false;
      })
    },
    goCollectionList(type, exhibitionId) {
      if (type === 'older') {
        this.$router.push({
          path: '/exhibitions/v1/' + exhibitionId + '/collections'
        })
      } else {
        this.$router.push({
          path: '/exhibitions/v2/' + exhibitionId + '/collections'
        })
      }
    },
    goExhibition(type, id) {
      if (type === 'older') {
        this.$router.push({
          path: '/exhibitions/v1/' + id
        })
      } else {
        this.$router.push({
          path: '/exhibitions/v2/' + id
        })
      }
    },
    handleUpdateStatus(exhibition, status) {
      const openEnd = new Date(exhibition['open_end_at']);
      const exhibitionId = exhibition['exhibition_id'];
      if (status === 'inKeep') {
        if (openEnd < new Date()) {
          this.$confirm('此展覽已過期，若取消KEEP，系統將會自動移到歷史展覽，APP將不會顯示！', '確定要取消KEEP?', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleSubmitStatue(exhibitionId, 'history')
          }).catch(() => {
          });
        } else {
          this.handleSubmitStatue(exhibitionId, 'online')
        }
      } else if (status === 'online' && openEnd < new Date()) {
        this.$confirm('此展覽已過期，若要上架，系統將會自動加上KEEP狀態！', '確定要取消KEEP?', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleSubmitStatue(exhibitionId, 'keep')
        }).catch(() => {
        });
      } else if (status === 'offline') {
        if (openEnd < new Date()) {
          this.$confirm('此展覽已過期，系統將會自動移到歷史展覽，APP將不會顯示！', '確定要下架?', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleSubmitStatue(exhibitionId, 'history')
          }).catch(() => {
          });
        } else {
          this.handleSubmitStatue(exhibitionId, 'prepare')
        }
      } else {
        this.handleSubmitStatue(exhibitionId, status)
      }
    },
    handleSubmitStatue(id, status) {
      this.listLoading = true;
      this.submitUpdateStatue(id, status).then(response => {
        this.listLoading = false;
        if (response.status) {
          this.getExhibitionList();
        } else {
          this.$message({
            type: 'error',
            message: response.message
          });
        }
      }).catch(err => {
        this.listLoading = false;
        this.$alert(err, '發生錯誤', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
      })
    },
    async submitUpdateStatue(id, status) {
      try {
        if(status === 'online' || status === 'keep') {
          const exhibitionResult = await fetchExhibitionList({
            where: {
              or: [{
                status: 'online'
              }, {
                status: 'keep'
              }]
            }
          });
          /* 2022/05/26 App 3.0.5 版本已取消六檔限制
          if (exhibitionResult.data.length >= 6) {
            return Promise.resolve({
              status: false,
              message: '線上同時最多只能有六個展覽'
            })
          }
           */
        }
        await updateExhibition(id, {
          status: status
        });
        return Promise.resolve({
          status: true
        })
      } catch (e) {
        return Promise.reject(e);
      }
    },
    handleChangeEnableEn(exhibitionId) {
      const exhibition = this.exhibitionList.filter(x => x.exhibition_id === exhibitionId)[0]
      if (exhibition) {
        const enableEn = exhibition.enable_en
        this.$confirm(`請確認是否${enableEn ? '啟用' : '停用'}-英文展覽`, '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          updateExhibition(exhibitionId, { enable_en: enableEn}).then(response => {
            this.listLoading = false;
            if (response.status) {
              this.getExhibitionList();
            } else {
              this.$message({
                type: 'error',
                message: response.message
              });
            }
          }).catch(err => {
            this.listLoading = false;
            this.$alert(err, '發生錯誤', {
              confirmButtonText: '確定',
              callback: action => {
              }
            });
          })
        }).catch(() => {
        });
      }
    },
  }
}
</script>

<style lang="scss">
.exhibition-container {
  .public-content {
    background: #f4f3ef;
    width: 100%;
    height: 80px;
    text-align: center;
    line-height: 80px;
    padding-bottom: 70px;
    span {
      visibility: hidden;
      cursor: pointer;
    }
  }
  .drag-sort {
    background: #f4f3ef;
    width: 100%;
    height: 80px;
    text-align: center;
    line-height: 80px;
    span {
      visibility: hidden;
      cursor: pointer;
    }
  }
  .keep {
    span {
      font-weight: bolder;
      cursor: pointer;
    }
    .inKeep {
      color: #27A5C1;
    }
    .online {
      color: lightgrey;
    }
  }
  .el-table__row:hover {
    .public-content {
      span {
        visibility: visible;
      }
    }
  }
  table {
    border-collapse:separate;
    border-spacing:0 10px;
    background-color: #f4f3ef;
    padding-right: 1px;
    width: 100% !important;
    td {
      padding: 0;
      border-width: 0;
      .cell {
        padding: 0;
      }
    }
  }
  .exhibition-title {
    padding: 10px;
    line-height: 19px;
    span {
      cursor: pointer;
    }
    .exhibition-title-cht {
      /*font-weight: bold;*/
      font-size: 16px;
      color: black;
    }
  }
  .guide-button-content {
    height: 25px;
    width: 80px;
    border: 1px solid lightgray;
    line-height: 25px;
    text-align: center;
    font-size: 13px;
    border-radius: 13px;
    cursor: pointer;
  }
  .guide-button-content:hover {
    animation-name:guide-button-hover;
    animation-duration:100ms;
    animation-fill-mode: forwards;
  }
  @keyframes guide-button-hover {
    from{
      font-size: 13px;
      height: 25px;
      line-height: 25px;
      width: 80px;
      border-color: lightgray;
    }
    to{
      font-size: 12px;
      height: 23px;
      line-height: 23px;
      width: 78px;
      border-color: darkgrey;
    }
  }
  .el-pagination {
    float: right;
    .btn-prev {
      background: rgba(0, 0, 0, 0.01);
    }
    .el-dialog, .el-pager li {
      background: rgba(0, 0, 0, 0.01);
    }
    .btn-next {
      background: rgba(0, 0, 0, 0.01);
    }
  }
  .invisible-title {
    margin-top: 30px;
    font-size: 25px;
    line-height: 40px;
    font-weight: bolder;
  }
}
</style>
